import { Button, Col, Row } from "react-bootstrap"
import ProfileImage from "./ProfileImage"
import { ClientInfo, getStatusColor } from "../api/users/data"
import React from "react"

type UserItemProps = {
    user    : ClientInfo
    onClick : (user:ClientInfo) => void
}

const UserItem:React.FC<UserItemProps> = ({user, onClick}) => {
    return <Button 
        className="btn-outline-primary "
        variant="outline-primary" 
        onClick={ (e) => onClick(user)}>
        <Row>
            <Col sm="auto" style={{margin:"auto",padding:"0px"}}>
                <ProfileImage name={user.LastName} bgcolor="#D9D9D9"/>
            </Col>
            <Col>
                <div className="list1">{user.LastName + ", " + user.FirstName}</div>
                <div className="list1-sub" style={{color:getStatusColor(user.Status)}}>
                    {user.Status}
                </div>
            </Col>
        </Row>
    </Button>
}

export default UserItem